import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { currentDateAndTime, decodeData } from '../../Constants/constants';

// Sample blood group options
const PFApplicable = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];

const ESICApplicable = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];

const GRATUTYApplicable = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];

const PTApplicable = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];
const Applicable = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];
const OldOrNew = [ 
  { value: 'Old', label: 'Old' },
  { value: 'New', label: 'New' },
];


class StatutoryDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      employee_statutory_id: 0,
      pt_state: '',
      esicLocation: '',
      esicSubcode: '',
      pfApplicable: '0',
      esicApplicable: '0',
      gratutyApplicable: '0',
      ptApplicable: '0',
      pfNumber: '',
      uanNumber: '',
      esicNumber: '',
      errors: {} ,
      vpf_applicable:"0",
      lwf_Applicable:"0",
      bonus_applicable:"0",
      wc_applicable:"0",
      nps_applicable:"0",
      it_regime:"",
      statutory_detail_id:"",
      ptAndLwfLocationOptions:[],
      esicLocationOptions:[],
      lwf_state:"",
      decodedData: [],
    };
  }

  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetStateLocationList();
      this.GetInfo();
    });
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  handleFormSubmit = (e) => {
    e.preventDefault();
  
    const errors = {};
    if (this.state.pfApplicable === "Yes") {
      if (!this.state.uanNumber) {
        errors.uanNumber = "UAN Number is required.";
      }
      if (!this.state.pfNumber) {
        errors.pfNumber = "PF Number is required.";
      }
    }
  
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
  
    // Submit the form
    console.log("Form submitted:", this.state);
  };
  

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  // handleInputPercent = (e) => {
  //   const { name, value } = e.target;

  //   // Clear the specific error related to the changed input
  //   this.setState((prevState) => ({
  //     [name]: value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: '',
  //     },
  //   }));
  // };

  // Handler function for Select component change
  // handleSelectChange = (name, selectedOption) => {
  //   // Clear the specific error related to the changed input
  //   this.setState((prevState) => ({
  //     [name]: selectedOption.value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: '',
  //     },
  //   }));
  // };

  handleSelectChange = (name, selectedOption) => {
    const value = selectedOption.value;
  console.log("name",name);
  console.log("value",value);
    this.setState((prevState) => ({
      [name]: value,
      
      errors: {
        ...prevState.errors,
        [name]: '',
      },
      
      ...(name === 'pfApplicable' && value === 'No' ? { uanNumber: '', pfNumber: '' } : {}),
    }));
  };
  

  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    axios.get(`${apiURL}Employees/GetStatutoryDetailsInfo`, { params: { employee_id: employee_id }, headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true && data.length !== 0) {
        this.setState(
          {
            // employee_statutory_id: data[0].employee_statutory_id,
            statutory_detail_id: data[0].statutory_detail_id,
            employee_id: data[0].employee_id,
            pfApplicable: data[0].pf_applicable || "0" ,
            pfNumber: data[0].pf_number,
            lwf_Applicable: data[0].lwf_applicable || "0" ,
            lwf_state: parseInt(data[0].lwf_state) || null ,
            vpf_applicable: data[0].vpf_applicable || "0" ,
            vpf_percent: data[0].vpf_percent,
            bonus_applicable: data[0].bonus_applicable || "0" ,
            wc_applicable: data[0].wc_applicable || "0" ,
            nps_applicable: data[0].nps_applicable || "0" ,
            it_regime: data[0].it_regime,
            esicApplicable: data[0].esic_applicable || "0" ,
            esicNumber: data[0].esic_number,
            esicLocation: parseInt(data[0].esic_location),
            esicSubcode: data[0].esic_subcode,
            ptApplicable: data[0].pt_applicable || "0" ,
            pt_state: parseInt(data[0].pt_location) || null ,
            gratutyApplicable: data[0].gratuity_applicable || "0" ,
            uanNumber: data[0].uan_number,
          }
        )
      }
    });
  }
  GetStateLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
      axios.get(`${apiURL}Masters/GetPTAndLWFStateList`, { params: { pt_lwf_limit: 9999, page: 1, keyword: this.state.keyword }, headers }).then((response) => {
        var data = response.data;
        console.log("GetPTAndLWFStateList",data)
        if (response.data.success === true) {
          const tempRows= data?.data?.map((val)=>{
            return { value: val?.pt_lwf_state_id, label: val?.pt_lwf_state_title }
          });
            this.setState({
              ptAndLwfLocationOptions: tempRows || [],
            });
        }
    });
      axios.get(`${apiURL}Masters/GetESICLocationList`, { params: { limit: 9999, page: 1 }, headers }).then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          const tempRows= data?.data?.map((val)=>{
            return { value: val?.esic_location_id, label: val?.esic_location_title }
          });
            this.setState({
              esicLocationOptions: tempRows || [],
            });
        }
    });
  }

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    const errors = this.validateForm();
    console.log("errors",errors);
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    this.setState({ loadingPost:true });
    let formData = {
      statutory_detail_id: this.state.statutory_detail_id || null,
      employee_id: employee_id,
      pf_applicable: this.state.pfApplicable,
      pf_number: this.state.pfNumber,
      lwf_applicable: this.state.lwf_Applicable,
      vpf_applicable: this.state.vpf_applicable,
      vpf_percent: this.state.vpf_percent,
      bonus_applicable: this.state.bonus_applicable,
      wc_applicable: this.state.wc_applicable,
      nps_applicable: this.state.nps_applicable,
      it_regime: this.state.it_regime,
      esic_applicable: this.state.esicApplicable,
      esic_number: this.state.esicNumber,
      esic_location: this.state.esicLocation,
      esic_subcode: this.state.esicSubcode,
      pt_applicable: this.state.ptApplicable,
      pt_location: this.state.pt_state,
      gratuity_applicable: this.state.gratutyApplicable,
      uan_number: this.state.uanNumber,
      lwf_state: this.state.lwf_state,
      date: currentDateAndTime(),
    };

    if (this.state.employee_statutory_id !== 0) {
      formData.employee_statutory_id = this.state.employee_statutory_id;
    }
    console.log(formData);
    

    axios.post(`${apiURL}Employees/CreateStatutory`, formData, { headers }).then((response) => {
      const { success } = response.data;

      if (success === true) {
        this.setState({
          loadingPost:false,
          employee_statutory_id: 0,
          employee_id: 0,
          pfApplicable: 'Yes',
          pfNumber: '',
          esicApplicable: '',
          esicNumber: '',
          esicLocation: '',
          esicSubcode: '',
          ptApplicable: '',
          pt_state: '',
          gratutyApplicable: '',
          uanNumber: '',
          lwf_state: '',
        });
        // this.closeRef.current.click();

        this.setState({ loadingList: true }, (prevState) => {
          this.GetInfo();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingPost:false, loadingList: true })
      }

    })
  };

  validateForm = () => {
    const errors = {};

    if (this.state.pfApplicable === '1') {
      if (!this.state.uanNumber) {
        errors.uanNumber = 'UAN Number is required';
      } else if (!/^\d{12}$/.test(this.state.uanNumber)) {
        errors.uanNumber = 'Invalid UAN Number. Must be a 12-digit number.';
      }
    }
    if (this.state.vpf_applicable === '1') {
      console.log(/^\d{3}$/.test(this.state.vpf_percent),!parseInt(this.state.vpf_percent) <= 100)
      if (!this.state.vpf_percent) {
        errors.vpf_percent = 'VPF Percent is required';
      } else if (/^\d{3}$/.test(this.state.vpf_percent)) {
        errors.vpf_percent = 'Invalid VPF Percent. Must be less than 100.';
      }
      else if((parseInt(this.state.vpf_percent) > 100) ){
        errors.vpf_percent = 'Invalid VPF Percent. Must be less than 100.';
      }
    }
    if(!this.state.lwf_Applicable){
      errors.lwf_Applicable="This field is required!"
    }
    if(this.state.lwf_Applicable==="1" && !this.state.lwf_state){
      errors.lwf_state="This field is required!"
    }
    if(!this.state.it_regime){
      errors.it_regime="This field is required!"
    }
    if (this.state.esicApplicable === '1') {
      // console.log(this.state.esicApplicable,this.state.esicLocation)
      if (!this.state.esicLocation) {
        errors.esicLocation = 'ESIC Location is required';
      }
      if (!this.state.esicNumber) {
        errors.esicNumber = 'ESIC Number is required';
      } 
      else if (!/^\d{10}$/.test(this.state.esicNumber)) {
        errors.esicNumber = 'Invalid ESIC Number. Must be a 10-digit number.';
      }
      if (!this.state.esicSubcode ) {
        errors.esicSubcode = 'ESIC Subcode is required';
      }
      else if(!/^\d{2,6}[-/]?[A-Z0-9]{1,5}$/i.test(this.state.esicSubcode)){
        errors.esicSubcode = 'Invalid ESIC Subcode. Must be 5 characters long and alphanumeric.';
      }
    } 

    

    
    if (this.state.pfNumber && !/^[A-Z]{5}\d{17}$/.test(this.state.pfNumber)) {
      errors.pfNumber = 'Invalid PF Number.';
    }

    if (this.state.ptApplicable === '1' && !this.state.pt_state) {
        errors.pt_state = 'PT State is required';
    }
    
    return errors;
  };


  render() {
    const { errors } = this.state;
    return (
      <div>
        <h5>Statutory Details<span
          style={{
            color: "blue", marginLeft: "5px", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px",
          }}
        >
          *
        </span>
        </h5>
        <p className="text-muted">
          Fill all information below
        </p>


        <div className="container mt-2">
          <form onSubmit={this.handleSubmit}>
            {/* First Column */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="pfApplicable" className="form-label">PF Applicable:
            <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
          
        </label>
        <Select
          id="pfApplicable"
          name="pfApplicable"
          value={PFApplicable.find(option => option.value === this.state.pfApplicable)}
          onChange={(selectedOption) => this.handleSelectChange('pfApplicable', selectedOption)}
          options={PFApplicable}
          placeholder="Select PF Applicable"
        />
        {errors.pfApplicable && <div className="text-danger">{errors.pfApplicable}</div>}
      </div>

      {/* UAN Number */}
      <div className="col-md-6 mb-3">
        <label htmlFor="uanNumber" className="form-label">
          UAN Number:
          {this.state.pfApplicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
        </label>
        <input
          type="number"
          id="uanNumber"
          name="uanNumber"
          value={this.state.uanNumber}
          onChange={this.handleInputChange}
          className={`form-control ${errors.uanNumber ? 'is-invalid' : ''}`}
          placeholder="Enter UAN Number"
          required={this.state.pfApplicable === "1"} 
          // disabled={this.state.pfApplicable !== "1"} 
        />
        {errors.uanNumber && <div className="invalid-feedback">{errors.uanNumber}</div>}
      </div>

      {/* PF Number */}
      <div className="col-md-6 mb-3">
        <label htmlFor="pfNumber" className="form-label">
          PF Number:
          {this.state.pfApplicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
        </label>
        <input
          type="text"
          id="pfNumber"
          name="pfNumber"
          value={this.state.pfNumber}
          onChange={this.handleInputChange}
          className={`form-control ${errors.pfNumber ? 'is-invalid' : ''}`}
          placeholder="Enter PF Number"
          required={this.state.pfApplicable === "Yes"} 
          // disabled={this.state.pfApplicable !== "Yes"} 
        />
        {errors.pfNumber && <div className="invalid-feedback">{errors.pfNumber}</div>}
      </div>
              <div className="col-md-6 mb-3"></div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="vpf_applicable" className="form-label">VPF Applicable: 
                  <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                  </label>
                  <Select
                    id="vpf_applicable"
                    name="vpf_applicable"
                    value={Applicable.find(option => option.value === this.state.vpf_applicable)}
                    onChange={(selectedOption) => this.handleSelectChange('vpf_applicable', selectedOption)}
                    options={Applicable}
                    placeholder="Select VPF Applicable"
                  />
                  {errors.vpf_applicable && <div className="text-danger">{errors.vpf_applicable}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="vpf_percent" className="form-label">VPF Percent:
                  {this.state.vpf_applicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
                  </label>
                  <input
                    type="text"
                    id="vpf_percent"
                    name="vpf_percent"
                    value={this.state.vpf_percent}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.vpf_percent ? 'is-invalid' : ''}`}
                    placeholder="Enter VPF Percent"
                  />
                  {errors.vpf_percent && <div className="invalid-feedback">{errors.vpf_percent}</div>}
                </div>
                {/* <div className="col-md-6 mb-3"></div> */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="lwf_Applicable" className="form-label">LWF Applicable:
                  <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                  </label>
                  <Select
                    id="lwf_Applicable"
                    name="lwf_Applicable"
                    value={Applicable.find(option => option.value === this.state.lwf_Applicable)}
                    onChange={(selectedOption) => this.handleSelectChange('lwf_Applicable', selectedOption)}
                    options={Applicable}
                    placeholder="Select LWF Applicable"
                  />
                  {errors.lwf_Applicable && <div className="text-danger">{errors.lwf_Applicable}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="lwf_Applicable" className="form-label">LWF State
                  {this.state.lwf_Applicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
                  </label>
                  <Select
                    id="lwf_state"
                    name="lwf_state"
                    value={this.state.lwf_state? this.state.ptAndLwfLocationOptions.find(option => option.value === this.state.lwf_state):null}
                    onChange={(selectedOption) => this.handleSelectChange('lwf_state', selectedOption)}
                    options={this.state.ptAndLwfLocationOptions}
                    placeholder="Select State"
                    styles={{
                      control: (base, state) => ({
                          ...base,
                          borderColor: errors?.lwf_state ? "red" : base.borderColor,
                          boxShadow: errors?.lwf_state ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                          "&:hover": {
                              borderColor: errors?.lwf_state ? "red" : base.borderColor,
                          },
                      }),
                  }}
                  />
                  {errors.lwf_state && <div className="text-danger">{errors.lwf_state}</div>}
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="bonus_applicable" className="form-label">Bonus Applicable:
                  <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                  </label>
                  <Select
                    id="bonus_applicable"
                    name="bonus_applicable"
                    value={Applicable.find(option => option.value === this.state.bonus_applicable)}
                    onChange={(selectedOption) => this.handleSelectChange('bonus_applicable', selectedOption)}
                    options={Applicable}
                    placeholder="Select LWF Applicable"
                  />
                  {errors.bonus_applicable && <div className="text-danger">{errors.bonus_applicable}</div>}
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="wc_applicable" className="form-label">WC Applicable:
                  <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                  </label>
                  <Select
                    id="wc_applicable"
                    name="wc_applicable"
                    value={Applicable.find(option => option.value === this.state.wc_applicable)}
                    onChange={(selectedOption) => this.handleSelectChange('wc_applicable', selectedOption)}
                    options={Applicable}
                    placeholder="Select LWF Applicable"
                  />
                  {errors.wc_applicable && <div className="text-danger">{errors.wc_applicable}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="nps_applicable" className="form-label">NPS Applicable:
                  <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                  </label>
                  <Select
                    id="nps_applicable"
                    name="nps_applicable"
                    value={Applicable.find(option => option.value === this.state.nps_applicable)}
                    onChange={(selectedOption) => this.handleSelectChange('nps_applicable', selectedOption)}
                    options={Applicable}
                    placeholder="Select LWF Applicable"
                  />
                  {errors.nps_applicable && <div className="text-danger">{errors.nps_applicable}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="it_regime" className="form-label">IT Regime:
                   <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                  </label>
                  <Select
                    id="it_regime"
                    name="it_regime"
                    value={OldOrNew.find(option => option.value === this.state.it_regime)}
                    onChange={(selectedOption) => this.handleSelectChange('it_regime', selectedOption)}
                    options={OldOrNew}
                    placeholder="Select"
                  />
                  {errors.it_regime && <div className="text-danger">{errors.it_regime}</div>}
                </div>
             

              <div className="col-md-6 mb-3">
                <label htmlFor="esicApplicable" className="form-label">ESIC Applicable:
                <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                </label>
                <Select
                  id="esicApplicable"
                  name="esicApplicable"
                  value={ESICApplicable.find(option => option.value === this.state.esicApplicable)}
                  onChange={(selectedOption) => this.handleSelectChange('esicApplicable', selectedOption)}
                  options={ESICApplicable}
                  placeholder="Select ESIC Applicable"
                />
                {errors.esicApplicable && <div className="text-danger">{errors.esicApplicable}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="esicNumber" className="form-label">ESIC Number:
                {this.state.esicApplicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
                </label>
                <input
                  type="number"
                  id="esicNumber"
                  name="esicNumber"
                  value={this.state.esicNumber}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.esicNumber ? 'is-invalid' : ''}`}
                  placeholder="Enter ESIC Number"
                />
                {errors.esicNumber && <div className="invalid-feedback">{errors.esicNumber}</div>}
              </div>


              <div className="col-md-6 mb-3">
                <label htmlFor="esicLocation" className="form-label">ESIC Location:
                {this.state.esicApplicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
                </label>
                {/* <input
                  type="text"
                  id="esicLocation"
                  name="esicLocation"
                  value={this.state.esicLocation}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.esicLocation ? 'is-invalid' : ''}`}
                  placeholder="Enter ESIC Location"
                /> */}
                <Select
                  id="esicLocation"
                  name="esicLocation"
                  value={this.state.esicLocation ? this.state.esicLocationOptions.find(option => option.value === this.state.esicLocation) : null}
                  onChange={(selectedOption) => this.handleSelectChange('esicLocation', selectedOption)}
                  options={this.state.esicLocationOptions}
                  placeholder="Select Location"
                  styles={{
                    control: (base, state) => ({
                        ...base,
                        borderColor: errors?.esicLocation ? "red" : base.borderColor,
                        boxShadow: errors?.esicLocation ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                        "&:hover": {
                            borderColor: errors?.esicLocation ? "red" : base.borderColor,
                        },
                    }),
                }} />
                {errors.esicLocation && <div className="text-danger">{errors.esicLocation}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="esicSubcode" className="form-label">ESIC Subcode:</label>
                <input
                  type="text"
                  id="esicSubcode"
                  name="esicSubcode"
                  value={this.state.esicSubcode}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.esicSubcode ? 'is-invalid' : ''}`}
                  placeholder="Enter ESIC Subcode"
                />
                {errors.esicSubcode && <div className="invalid-feedback">{errors.esicSubcode}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="ptApplicable" className="form-label">PT Applicable:
                <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>
                </label>
                <Select
                  id="ptApplicable"
                  name="ptApplicable"
                  value={PTApplicable.find(option => option.value === this.state.ptApplicable)}
                  onChange={(selectedOption) => this.handleSelectChange('ptApplicable', selectedOption)}
                  options={PTApplicable}
                  placeholder="Select PT Applicable"
                />
                {errors.ptApplicable && <div className="text-danger">{errors.ptApplicable}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="pt_state" className="form-label">PT State:
                {this.state.ptApplicable === "1" && <span
              style={{
                color: "blue",marginLeft: "5px",borderRadius: "50%",background: "#f0f8ff",padding: "2px 6px",display: "inline-block",textAlign: "center",width: "20px",height: "20px",
                lineHeight: "20px",
              }}
            >
              *
            </span>}
                </label>
                {/* <input
                  type="text"
                  id="pt_state"
                  name="pt_state"
                  value={this.state.pt_state}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.pt_state ? 'is-invalid' : ''}`}
                  placeholder="Enter PT Location"
                /> */}
                 <Select
                  id="pt_state"
                  name="pt_state"
                  value={this.state.pt_state ? this.state.ptAndLwfLocationOptions.find(option => option.value === this.state.pt_state) : null}
                  onChange={(selectedOption) => this.handleSelectChange('pt_state', selectedOption)}
                  options={this.state.ptAndLwfLocationOptions}
                  placeholder="Select State"
                  styles={{
                    control: (base, state) => ({
                        ...base,
                        borderColor: errors?.pt_state ? "red" : base.borderColor,
                        boxShadow: errors?.pt_state ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                        "&:hover": {
                            borderColor: errors?.pt_state ? "red" : base.borderColor,
                        },
                    }),
                }} />
                 
                {errors.pt_state && <div className="text-danger">{errors.pt_state}</div>}
              </div>

            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="gratutyApplicable" className="form-label">Gratuty Applicable:</label>
                <Select
                  id="gratutyApplicable"
                  name="gratutyApplicable"
                  value={GRATUTYApplicable.find(option => option.value === this.state.gratutyApplicable)}
                  onChange={(selectedOption) => this.handleSelectChange('gratutyApplicable', selectedOption)}
                  options={GRATUTYApplicable}
                  placeholder="Select Gratuty Applicable"
                />
                {errors.gratutyApplicable && <div className="text-danger">{errors.gratutyApplicable}</div>}
              </div>

            </div>
            <div className="d-flex justify-content-end" >
              <button type="submit" className={`btn btn-success ${!this.state.loadingPost && "btn-label"} waves-effect right waves-light`}>
              <span className="d-flex align-items-center gap-1">
              {this.state.loadingPost ? (
                  <span
                    class="spinner-border flex-shrink-0 "
                    role="status"
                    style={{
                      width: "1.2rem",
                      height: "1.2rem",
                      borderWidth: "2px",
                      }}
                  >
                    <span class="visually-hidden">Loading...</span>
                  </span>
                ) : (
                  <i className="bx bx-save label-icon align-middle fs-16 ms-2" />
                )}
                 Save
                 </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(StatutoryDetails);
